/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ISzfContactUsData } from './szf-contact-us.data';
import { ISzfContactUsProps } from './szf-contact-us.props.autogenerated';

export interface ISzfContactUsViewProps extends ISzfContactUsProps<ISzfContactUsData> {}

/**
 *
 * SzfContactUs component
 * @extends {React.PureComponent<ISzfContactUsProps<ISzfContactUsData>>}
 */
class SzfContactUs extends React.PureComponent<ISzfContactUsProps<ISzfContactUsData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default SzfContactUs;
